export default __webpack_public_path__ + "static/media/shoes1-afterA-480w.53154fdf.webp";